export const MODULE_ID_PUSH_MESSAGES = "VirtoCommerce.PushMessages";
